<div style="padding-top:100px;width: 100%; position: absolute; display: flex; flex-direction: row; justify-content: center; align-items: center;">
	<app-metro class="metro" style="position: relative; width: 74vh; height: 74vh;" ></app-metro>
</div>


	<app-transport style="top:90px;position:absolute;width: 100px;"></app-transport>
	<span class="metro-infos" aria-label="Right click in the middle of the screen to see the metronome options">
	   <i class="fas fa-question"></i>
	</span>